import { ApiHelper } from "../heplers/APIHelper";

const apiHelper = new ApiHelper();

/**
 * 🔹 Get blocked channels
 */
export const getBlockedChannels = (cancelToken?: any) => {
  return apiHelper.get("block/list", { type: "channel" }, cancelToken);
};

/**
 * 🔹 Get blocked videos
 */
export const getBlockedVideos = (cancelToken?: any) => {
  return apiHelper.get("block/list", { type: "video" }, cancelToken);
};

/**
 * 🔹 Block a channel
 */
export const blockChannel = (id: string) => {
  return apiHelper.post("block", { id, type: "channel" });
};

/**
 * 🔹 Block a video
 */
export const blockVideo = (id: string) => {
  return apiHelper.post("block", { id, type: "video" });
};

/**
 * 🔹 Unblock channel
 */
export const unblockChannel = (id: string) => {
  return apiHelper.delete("block", { id, type: "channel" });
};

/**
 * 🔹 Unblock video
 */
export const unblockVideo = (id: string) => {
  return apiHelper.delete("block", { id, type: "video" });
};
